import { render } from "./FileUploadPrompt.vue?vue&type=template&id=614e4817&scoped=true&ts=true"
import script from "./FileUploadPrompt.vue?vue&type=script&lang=ts"
export * from "./FileUploadPrompt.vue?vue&type=script&lang=ts"

import "./FileUploadPrompt.vue?vue&type=style&index=0&id=614e4817&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614e4817"]])

export default __exports__